/* istanbul ignore file */
// TODO: ^ ignore coverage on this file until we can have app test scaffolding ready
import React from 'react'
import { connect } from 'react-redux'
import ResourceLanding from './component'
import { FlaggedRouteContentGetter as RouteContentGetter } from 'layers/content/v2/Hocs/FlaggedRouteContentGetter'
import { navigationEvent } from 'layers/navigation/store/operations'
import withApiError from 'layers/errorHandling/apiError'
import { resolveRouteServiceApp } from 'utils/routing/routeHelpers'

const Container = props => {
  const { routeContent } = props || {}
  const { content = {}, loading } = routeContent || {}
  const { programSectionArticleTree } = content || {}

  const readyToLoad = !!content && !loading

  return (
    readyToLoad && (
      <ResourceLanding
        programSectionArticleTree={programSectionArticleTree}
        {...props}
      />
    )
  )
}

const mapStateToProps = state => ({
  productTabTitle: state.productManager?.productMap?.name || '',
})

const mapDispatchtoProps = {
  navigationEvent,
}

const options = {
  app: ({ route }) => resolveRouteServiceApp(route),
  routeResolver: () => window?.location?.pathname,
}

const ConnectedResourcesContentContainer = connect(
  mapStateToProps,
  mapDispatchtoProps,
)(Container)

export default RouteContentGetter(
  withApiError(ConnectedResourcesContentContainer),
  options,
)
